import React, { useState, useEffect } from 'react';
import { Table, Select, Col, Row, Pagination, Input, Tooltip } from 'antd';
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import Dropdown from 'react-bootstrap/Dropdown';
import addIcon from '../../assets/images/icons/add.svg';
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import crossIcon from '../../assets/images/icons/cross.svg';
import editIcon from '../../assets/images/icons/edit.svg';
import checkIcon from '../../assets/images/icons/check.svg';
import TableDocIcon from '../../assets/newlayout/table_doc_icon.svg';
import MPCreatePlan from './MPCreatePlan';

const googleSheetIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="3" y="1.5" width="10" height="13" rx="1" stroke="#64748B" strokeWidth="1.3" />
        <path d="M5.5 5.5H10.5" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" />
        <path d="M5.5 8H10.5" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" />
        <path d="M5.5 10.5H8.5" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

const customizeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip_action_cust)">
            <path d="M2.33325 12.2501V8.16675" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.33325 5.83333V1.75" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 12.25V7" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 4.66667V1.75" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6667 12.2499V9.33325" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6667 7V1.75" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M0.583252 8.16675H4.08325" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.25 4.66675H8.75" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.91675 9.33325H13.4167" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip_action_cust">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const searchIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 14.0001L11.1 11.1001" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const baseMediaPlans = [
    {
        id: 1,
        status: 'active',
        name: 'Daily Adkernel File Analysis',
        schedule: '7 Days',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
        googleSheetUrl: 'https://docs.google.com/spreadsheets/d/sample1',
    },
    {
        id: 2,
        status: 'inactive',
        name: 'Weekly Revenue Report',
        schedule: '15 Days',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
        googleSheetUrl: 'https://docs.google.com/spreadsheets/d/sample2',
    },
    {
        id: 3,
        status: 'inactive',
        name: 'Weekly Revenue Report',
        schedule: '-',
        lastUpdatedAt: 'Mar 20, 2026 | 20:03:23 PST',
        createdBy: 'harshil@xapads.com',
        createdAt: 'Mar 20, 2026 | 20:03:23 PST',
        googleSheetUrl: 'https://docs.google.com/spreadsheets/d/sample3',
    },
];

const mediaPlanRows = Array.from({ length: 234 }, (_, index) => {
    const baseRow = baseMediaPlans[index % baseMediaPlans.length];
    return {
        ...baseRow,
        id: index + 1,
        key: index + 1,
        name: index < 3 ? baseRow.name : `${baseRow.name} ${index + 1}`,
        googleSheetUrl: `https://docs.google.com/spreadsheets/d/sample${index + 1}`,
    };
});

const statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
];

const statusClassMap = {
    active: 'approved',
    inactive: 'declined',
    archived: 'archived',
};

const scheduleOptions = [
    { label: '7 Days', value: '7 Days' },
    { label: '15 Days', value: '15 Days' },
    { label: '30 Days', value: '30 Days' },
];

const LISTING_COL_OPTIONS = [
    { label: 'Status', value: 'status' },
    { label: 'Name', value: 'name' },
    { label: 'Schedule', value: 'schedule' },
    { label: 'Last Updated At', value: 'lastUpdatedAt' },
    { label: 'Created At', value: 'createdAt' },
];

const MediaPlannerV2 = () => {
    const [view, setView] = useState('listing'); // 'listing' | 'create'
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({ current: 1, pageSize: 20 });
    const [tableData, setTableData] = useState(mediaPlanRows);
    const [editingSchedule, setEditingSchedule] = useState(null); // { key, value }
    const [scheduleLoading, setScheduleLoading] = useState(false);
    const [colvis, setColvis] = useState({
        status: true,
        name: true,
        schedule: true,
        lastUpdatedAt: true,
        createdAt: true,
    });

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        // axios
        //     .get(configData.SERVER_URL + "adsTxt/filters", {
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //     })
        //     .then((response) => {
        //         setFilterDropdowns(response.data.result);
        //     })
        //     .catch((error) => { });

        // getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (view === 'create') {
        return <MPCreatePlan onBack={() => setView('listing')} />;
    }

    const filteredData = tableData.filter((item) => {
        const s = search.trim().toLowerCase();
        if (!s) return true;
        return (
            item.name.toLowerCase().includes(s) ||
            item.status.toLowerCase().includes(s) ||
            item.createdBy.toLowerCase().includes(s)
        );
    });

    const startIndex = (page.current - 1) * page.pageSize;
    const paginatedData = filteredData.slice(startIndex, startIndex + page.pageSize);

    const handleStatusChange = (key, value) => {
        setTableData(prev => prev.map(item => item.key === key ? { ...item, status: value } : item));
    };

    const handlePageChange = (currentPage) => {
        setPage(prev => ({ ...prev, current: currentPage }));
    };

    const handlePageSizeChange = (pageSize) => {
        setPage({ current: 1, pageSize });
    };

    const handleScheduleEditStart = (record) => {
        setEditingSchedule({ key: record.key, value: record.schedule });
    };

    const handleScheduleChange = (value) => {
        setEditingSchedule(prev => prev ? { ...prev, value } : prev);
    };

    const handleScheduleSave = () => {
        if (!editingSchedule) return;
        setScheduleLoading(true);
        // Hit sample123 endpoint
        setTimeout(() => {
            setTableData(prev => prev.map(item =>
                item.key === editingSchedule.key ? { ...item, schedule: editingSchedule.value } : item
            ));
            setEditingSchedule(null);
            setScheduleLoading(false);
        }, 500);
    };

    const handleScheduleCancel = () => {
        setEditingSchedule(null);
    };

    const isIndeterminate = (vis) => {
        const vals = Object.values(vis);
        return vals.some(v => v) && !vals.every(v => v);
    };

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') return <span><img src={prevIcon} alt='prev' /></span>;
        if (type === 'next') return <span><img src={nextIcon} alt='next' /></span>;
        return originalElement;
    };

    const openGoogleSheet = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 72,
            render: (_, record) => (
                <div className='btn_group align-items-center'>
                    <Tooltip title="Open Google Sheet">
                        <button
                            className='download_icon download_icon_d2'
                            type='button'
                            onClick={() => openGoogleSheet(record.googleSheetUrl)}
                        >
                            <img src={TableDocIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    {/* <Tooltip title="Customize">
                        <button
                            className='download_icon download_icon_d2'
                            type='button'
                            onClick={() => setView('create')}
                        >
                            {customizeIcon}
                        </button>
                    </Tooltip> */}
                </div>
            ),
        },
        ...(colvis.status ? [{
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 96,
            render: (text, record) => {
                if (text === 'inactive') {
                    return (
                        <Tooltip title="Inactive media plan">
                            <div className='new_mp_table_inactive_status_tag'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clipPath="url(#clip_inactive)">
                                        <path d="M6.99935 12.8334C10.221 12.8334 12.8327 10.2217 12.8327 7.00008C12.8327 3.77842 10.221 1.16675 6.99935 1.16675C3.77769 1.16675 1.16602 3.77842 1.16602 7.00008C1.16602 10.2217 3.77769 12.8334 6.99935 12.8334Z" stroke="#020617" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 4.66675V7.00008" stroke="#020617" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 9.33325H7.00583" stroke="#020617" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip_inactive">
                                            <rect width="14" height="14" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                Inactive
                            </div>
                        </Tooltip>
                    );
                }
                return (
                    <div className='w_100 position-relative'>
                        <Select
                            showSearch={false}
                            className={`form_select badge_content--${statusClassMap[text] || 'approved'}`}
                            dropdownStyle={{ width: '12rem' }}
                            value={text}
                            options={statusOptions}
                            onChange={(value) => handleStatusChange(record.key, value)}
                        />
                    </div>
                );
            },
        }] : []),
        ...(colvis.name ? [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 800,
            render: (text) => <div className='color_900'>{text}</div>,
        }] : []),
        ...(colvis.schedule ? [{
            title: 'Schedule',
            dataIndex: 'schedule',
            key: 'schedule',
            width: 215,
            render: (text, record) => {
                const isEditing = editingSchedule?.key === record.key;

                if (text === '-') {
                    return <div className='color_900'>-</div>;
                }

                if (isEditing) {
                    return (
                        <div className='d-flex align-items-center justify-content-between gap_8'>
                            <Select
                                showSearch={false}
                                className='form_select basic sm no_search'
                                style={{ width: '11rem' }}
                                value={editingSchedule.value}
                                options={scheduleOptions}
                                suffixIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 6L8 10L12 6" stroke="#475569" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                                onChange={handleScheduleChange}
                            />
                            <div className='btn_group d-flex align-items-center' style={{ gap: '0.8rem' }}>
                                <Tooltip title="Save">
                                    <button
                                        className='btn_outline_success btn --diff_clr_of_approved_box'
                                        style={{ width: '2.8rem', height: '2.8rem' }}
                                        type='button'
                                        onClick={handleScheduleSave}
                                        disabled={scheduleLoading}
                                    >
                                        <img src={checkIcon} alt='save' />
                                    </button>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                    <button
                                        className='btn_outline_danger btn --diff_clr_of_reject_box'
                                        type='button'
                                        onClick={handleScheduleCancel}
                                        disabled={scheduleLoading}
                                    >
                                        <img src={crossIcon} style={{ filter: 'none' }} alt='cancel' />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    );
                }

                return (
                    <div className='d-flex align-items-center justify-content-between' style={{ minWidth: '14rem', gap: '1.2rem' }}>
                        <div className='color_900'>{text}</div>
                        <Tooltip title="Edit Schedule">
                            <button
                                className='download_icon download_icon_d2'
                                type='button'
                                onClick={() => handleScheduleEditStart(record)}
                            >
                                <img src={editIcon} alt='edit' />
                            </button>
                        </Tooltip>
                    </div>
                );
            },
        }] : []),
        ...(colvis.lastUpdatedAt ? [{
            title: 'Last Updated At',
            dataIndex: 'lastUpdatedAt',
            key: 'lastUpdatedAt',
            width: 180,
            render: (text) => <div className='text_light_css'>{text}</div>,
        }] : []),
        ...(colvis.createdAt ? [{
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 190,
            render: (_, record) => (
                <div>
                    <div className='color_900'>{record.createdBy}</div>
                    <div className='text_light_css'>{record.createdAt}</div>
                </div>
            ),
        }] : []),
    ];

    return (
        <div className="container_box--wrapper pt_header --wrapper-v2">
            <div className="title_intro">
                <h1 className="heading">Media Planner</h1>
            </div>
            <div className={paginatedData.length > 0 ? 'table_and_filter_div --without_filter_div' : 'table_and_filter_div --without_filter_div --no_data_div_height'}>
                <div className="table_area_div">
                    <div className='searchbar_with_btns'>
                        <div className="d_flex align-items-center justify_content_between w_100">
                            <div>
                                <Input
                                    type='text'
                                    className='form_control basic'
                                    placeholder="Search"
                                    prefix={searchIcon}
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        setPage(prev => ({ ...prev, current: 1 }));
                                    }}
                                    style={{ width: '22rem' }}
                                />
                            </div>
                            <div className='btn_group align-items-center'>
                                {/* Columns dropdown */}
                                {/* <div className="column_hide_unhide_d3 column_hide_unhide_mediaplanner_d2 new_mp_columns_btn">
                                    <Dropdown autoClose="outside">
                                        <Dropdown.Toggle id="listing-columns-dropdown">
                                            <button className='btn btn_white_outline w_fit_content md' type='button'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ marginRight: '0.4rem' }}>
                                                    <path d="M1.5 3H5.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.5 3H12.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1.5 7H5.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.5 7H12.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1.5 11H5.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.5 11H12.5" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                Columns
                                            </button>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <div className="colunm_checkbox">
                                                <ul className="p-0 m-0">
                                                    <li>
                                                        <label htmlFor="listing_select_all">
                                                            <input
                                                                className={isIndeterminate(colvis) ? 'form-check-input parital_checkbox' : 'form-check-input'}
                                                                type="checkbox"
                                                                id="listing_select_all"
                                                                checked={Object.values(colvis).every(v => v)}
                                                                onChange={(e) => {
                                                                    const updated = Object.keys(colvis).reduce((acc, k) => {
                                                                        acc[k] = e.target.checked;
                                                                        return acc;
                                                                    }, {});
                                                                    setColvis(updated);
                                                                }}
                                                            />
                                                            <span>Select All</span>
                                                        </label>
                                                    </li>
                                                    <hr className="new_item_line_d3" />
                                                </ul>
                                                <ul className="p-0 m-0 colvis_scroll">
                                                    {LISTING_COL_OPTIONS.map(({ label, value }) => (
                                                        <li key={value}>
                                                            <label htmlFor={`listing_col_${value}`}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`listing_col_${value}`}
                                                                    checked={colvis[value]}
                                                                    onChange={() => setColvis(prev => ({ ...prev, [value]: !prev[value] }))}
                                                                />
                                                                <span>{label}</span>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div> */}

                                <button
                                    className='btn btn_primary w_fit_content md'
                                    type='button'
                                    onClick={() => setView('create')}
                                >
                                    <span><img src={addIcon} alt='add' /> Create New Media Plan</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                        <Table
                            columns={columns}
                            dataSource={paginatedData}
                            pagination={false}
                            rowKey="key"
                            scroll={{ x: paginatedData.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 31.2rem)' }}
                        />
                        {filteredData.length > 0 && (
                            <Row className="custom_pagination--container">
                                <Col span={6}>
                                    <div className="form_content_block--group mb_0">
                                        <Select
                                            className='form_select basic sm no_search'
                                            value={page.pageSize}
                                            onChange={handlePageSizeChange}
                                            style={{ width: 80 }}
                                            showSearch={false}
                                            options={[
                                                { value: 10, label: 10 },
                                                { value: 20, label: 20 },
                                                { value: 50, label: 50 },
                                                { value: 100, label: 100 },
                                            ]}
                                        />
                                        <label className='custom_pagination--label'>items per page</label>
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <span className="custom_pagination--total-text">
                                        {`${startIndex + 1}-${Math.min(page.current * page.pageSize, filteredData.length)} of ${filteredData.length} items`}
                                    </span>
                                </Col>
                                <Col span={6}>
                                    <Pagination
                                        current={page.current}
                                        pageSize={page.pageSize}
                                        total={filteredData.length}
                                        onChange={handlePageChange}
                                        showSizeChanger={false}
                                        itemRender={itemRender}
                                        className="custom_pagination"
                                    />
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MediaPlannerV2;
